export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.25-1351.27',
  commitId: '1dc7646755767301393bc5bb0edc6d8e4e5307c3',
  commitTime: '2026-02-25T13:51:27.000Z',
});
